//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import BusinessProcessMessages from '../../components/BusinessProcess/BusinessProcessMessages.vue'
import Table from '../../components/Table/Table.vue'
import TableCellObject from '../../components/Table/TableCellObject.vue'
import { formatTime } from '../../components/helpers.js'

export default {
  components: {
    BusinessProcessMessages,
    Table,
    TableCellObject
  },
  props: {
    stockInventoryTasks: {
      type: Array,
      required: true
    },
    employeeId: {
      type: Number,
      default: null
    },
    vehicleId: {
      type: Number,
      default: null
    }
  },
  data: function () {
    return {
      pagination: {
        rowsPerPage: 0,
        page: 1
      },
      columns: [
        {
          name: 'requestKey',
          label: '№',
          align: 'left',
          field: row => row.request.key,
          sortable: true,
          defaultWidth: 30
        },
        {
          name: 'bpState',
          label: 'Статус',
          align: 'left',
          field: row => row.bp.state.name,
          sortable: true
        },
        {
          name: 'executor',
          label: 'Исполнитель',
          align: 'left',
          field: row => row.request.executor,
          sortable: false,
          columnFormat: 'object',
          columnObjectType: 'employee',
          defaultWidth: 110
        },
        {
          name: 'vehicle',
          label: 'ТС',
          align: 'left',
          field: row => row.request.vehicle,
          sortable: false,
          columnFormat: 'object',
          columnObjectType: 'stock',
          defaultWidth: 110
        },
        {
          name: 'applicant',
          label: 'Заявитель',
          align: 'left',
          field: row => row.request.applicant,
          sortable: false,
          columnFormat: 'object',
          columnObjectType: 'employee'
        },

        {
          name: 'stock',
          label: 'Склад',
          align: 'left',
          field: row => row.request.stock,
          sortable: false,
          columnFormat: 'object',
          columnObjectType: 'stock',
          defaultWidth: 90
        },
        {
          name: 'requestCreateTime',
          label: 'Дата/время создания заявки',
          labelTable: 'Дата/время<br/>создания заявки',
          align: 'left',
          field: row => row.request.createTime,
          sortable: true,
          format: formatTime
        },
        {
          name: 'startTimeRequired',
          label: 'Требуемое время начала инвентаризации',
          labelTable: 'Требуемое время<br/>начала<br/>инвентаризации',
          align: 'left',
          field: row => row.request.startTimeRequired,
          sortable: true,
          format: formatTime
        },
        {
          name: 'endTimeRequired',
          label: 'Требуемое время завершения инвентаризации',
          labelTable: 'Требуемое время<br/>завершения<br/>инвентаризации',
          align: 'left',
          field: row => row.request.endTimeRequired,
          sortable: true,
          format: formatTime
        },
        {
          name: 'startTimeActual',
          label: 'Фактическое время начала инвентаризации',
          labelTable: 'Фактическое время<br/>начала<br/>инвентаризации',
          align: 'left',
          field: row => row.request.startTimeActual,
          sortable: true,
          format: formatTime
        },
        {
          name: 'endTimeActual',
          label: 'Фактическое время завершения инвентаризации',
          labelTable: 'Фактическое время<br/>завершения<br/>инвентаризации',
          align: 'left',
          field: row => row.request.endTimeActual,
          sortable: true,
          format: formatTime
        }
      ]
    }
  },
  computed: {
    foundTask: function () {
      return this.stockInventoryTasks.some(task => task.request.vehicle.id === this.vehicleId && ( //
        task.request.executor.id === this.employeeId || //
        task.bp.availableOwners && this.employeeId && task.bp.availableOwners.includes(this.employeeId)
      ))
    },
    title: function () {
      return this.foundTask ? 'Есть заявка на инвентаризацию склада с соответствующими параметрами' : 'Есть заявки на инвентаризацию склада, несоответствующие указанным параметрам'
    },
    bpMessages: function () {
      const messages = []
      for (const stockInventoryTask of this.stockInventoryTasks) {
        if (stockInventoryTask.bp && stockInventoryTask.bp.messages) {
          messages.push(...stockInventoryTask.bp.messages)
        }
      }
      return messages
    }
  },
  methods: {
    getTdStyle: function (col, row) {
      if (col.name === 'executor') {
        if (row.request.executor.id === this.employeeId) {
          return 'font-weight: 1000 !important;' +
                 'color: black !important;' +
                 'background-color: rgb(195, 254, 195) !important;'
        } else if (row.bp.availableOwners && this.employeeId && row.bp.availableOwners.includes(this.employeeId)) {
          return 'font-weight: 1000 !important;' +
                 'color: black !important;' +
                 'background-color: #ffffce !important;'
        } else {
          return 'font-weight: 1000 !important;' +
                 'color: black !important;' +
                 'background-color: #ffcfcf !important;'
        }
      } else if (col.name === 'vehicle') {
        if (row.request.vehicle.id === this.vehicleId) {
          return 'font-weight: 1000 !important;' +
                 'color: black !important;' +
                 'background-color: rgb(195, 254, 195) !important;'
        } else {
          return 'font-weight: 1000 !important;' +
                 'color: black !important;' +
                 'background-color: #ffcfcf !important;'
        }
      }
    },
    getTrClass: function (row) {
      if (row._notValid) {
        return 'd-tr--red'
      } else if (row.deleted) {
        return 'd-tr--gray'
      } else if (row.added) {
        return 'd-tr--green'
      }
    }
  }
}

